<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.subjects") }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight px-0">
    <div class="row">      
      <div
        v-if="roleprivileges.includes('ePRO Subjects Subject Schedule')"
        class="col-12 col-md-6 mb-1 pr-0"
      >
        <div class="ibox-body">
          <div class="ibox-content horizondalscroll minheight">
            <div v-if="showTreeLoading==true" class="text-center">
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
              <div>
                {{
                  $t("navigations.please wait while the tree is being loaded")
                }}
                </div>
            </div>
            <template v-else>
             <ul class="tree pl-1"  v-if="Object.keys(studyRef).length!=0">
              <li>
                <input type="checkbox" id="study-name" />
                <label class="tree_label" for="study-name">{{ studyRef  }}</label>
                <ul>
                  <li v-for="(site, sIndex) in sites" :key="site.siteID">
                    <input
                      type="checkbox"
                      :id="site.siteID"
                      @change="getpatient(site.siteID, sIndex)"
                    />
                    <label class="tree_label" :for="site.siteID">{{ site.siteCode }}</label>
                    <ul
                      v-for="(patient, pIndex) in patientLists[sIndex]"
                      :for="site.siteID"
                      :key="patient.patientId"
                    >
                      <li>
                        <input
                          type="checkbox"
                          :id="patient.patientId"
                          @change="getVisits(patient.patientId, pIndex)"
                        />
                        <label :for="patient.patientId" class="tree_label">{{
                          patient.subjectId
                        }}</label>
                        <ul
                          v-for="(visit, vIndex) in visitobj[patient.patientId][pIndex]"
                          :for="patient.patientId"
                          :key="visit.sheduleId"
                        >
                          <li>
                            <input
                              type="checkbox"
                              :id="visit.sheduleId + patient.patientId"
                              @change="
                                getFormsByVisit(
                                  patient.patientId,
                                  visit.visitNo,
                                  visit.visitName,
                                  vIndex,
                                  visit.sheduleId,
                                  site.siteCode,visit.patientNo
                                )
                              "
                            />
                            <label
                              :for="visit.sheduleId + patient.patientId"
                              class="tree_label"
                            >
                            <template v-if="visit.visitNo && visit.visitName">
                               {{ visit.visitNo }} - {{ visit.visitName }} - ( {{ setdate(visit) }} )
                                 <span class="badge custom-tooltip-wrapper"
                                    @mouseenter="showPopover(`visitStatus-${sIndex}-${pIndex}-${vIndex}`)"
                                    @mouseleave="hidePopover(`visitStatus-${sIndex}-${pIndex}-${vIndex}`)"
                                    :popovertarget="`visitStatus-${sIndex}-${pIndex}-${vIndex}`"
                                    :style="`background-color: ${visit.visitStatusHex}; color: black; anchor-name:--visitStatus-${sIndex}-${pIndex}-${vIndex};`">
                                    {{ visit.visitStatus }}
                                  </span>
                                
                          <span class="custom-tooltip-text"  v-if="visit.visitStatusDescription" popover
                            :id="`visitStatus-${sIndex}-${pIndex}-${vIndex}`" 
                            :style="`position-anchor:--visitStatus-${sIndex}-${pIndex}-${vIndex};`"
                            >{{ visit.visitStatusDescription }}</span>
                            </template>
                            <template v-else>
                            {{ $t('navigations.epro') }}
                            </template>
                            </label>
                            <span
                              class="position-relative cursor-pointer float-right px-2"
                              @click.prevent="toggleSidePopup(sIndex, pIndex, vIndex)"
                              v-on:clickout="closeSidePopup(sIndex, pIndex, vIndex)"
                            >
                              <i class="fa fa-ellipsis-v"></i>
                            </span>
                            <div
                              class="plan-side-popup"
                              v-if="
                                showSidePopup[sIndex] &&
                                showSidePopup[sIndex][pIndex] &&
                                showSidePopup[sIndex][pIndex][vIndex]
                              "
                            >
                              <!-- <div
                                @click.prevent="
                                  openModal(
                                    visit,
                                    patient.subjectId,
                                    site.siteCode,
                                    visit.visitStatus
                                  )
                                "
                              >
                                {{ $t("navigations.new form") }}
                              </div> -->
                              <div v-if="rollsprivilages.includes('ePRO Subjects Assign ePRO Form')"
                                @click.prevent = "openAssignFormModal(patient.patientId, visit.visitName, visit.visitNo,vIndex, visit.sheduleId, site.siteCode,visit.patientNo)"
                              >
                                {{ $t("navigations.assign ePRO form") }}
                              </div>
                              <div v-if="rollsprivilages.includes('ePRO Subjects Video Call')"
                                @click.prevent="openVideoCallSchedulePopup(patient.patientId)"
                              >
                                Video Call
                              </div>
                              <div
                              v-if="visit.visitStatus != 'Completed'"
                                @click.prevent="
                                  openChangeStatusmodal(
                                    visit.studyId,
                                    visit.visitNo,
                                    patient.patientId,
                                    visit.visitStatus,
                                    pIndex,
                                    'Visit'
                                  )
                                "
                              >
                                {{ $t("navigations.change status") }}
                              </div>
                            </div>
                            <template v-if="visitFormObj[visit.visitNo + patient.patientId]">
                              <ul>
                                <li v-if="observationValue[visit.visitNo+patient.patientId]==true">
                                  <input type="checkbox" />
                                  <label
                                    @click.prevent="
                                      toggleObservationFolder(
                                        visit.siteCode,
                                        visit.patientNo,
                                        visit.visitName,
                                        visit.visitNo,
                                        patient.patientId
                                      )
                                    "
                                    class="tree_label"
                                    >{{ $t("navigations.observations") }}</label
                                  >

                                  <template
                                    v-if="categoryFlags[visit.visitNo + patient.patientId]"
                                  >
                                    <div
                                      v-for="docType in categoryFlags[
                                        visit.visitNo + patient.patientId
                                      ]"
                                      :key="docType.id"
                                      class="tree-node mb-2"
                                    >
                                      <div @click.prevent="docType.flag = !docType.flag">
                                        <span class="cursor-pointer">
                                          <i class="fa fa-file-code-o text-primary me-2"></i>
                                          {{ docType.category }}
                                        </span>
                                      </div>
                                      <div class="row" v-if="docType.flag == true">
                                        <div
                                          class="d-flex pt-2 pl-4 cursor-pointer"
                                          v-for="(value, index) in docType.code"
                                          :key="index"
                                          @click.prevent="
                                            selectDocument(
                                              site.siteCode,
                                              patient.subjectId,
                                              docType.document[index],
                                              visit.visitName,
                                              patient.patientId,
                                              patient.siteId
                                            )
                                          "
                                        >
                                          <span class="mr-1">{{ value }}</span>
                                          <span v-if="docType.effectiveDateTime[index]">
                                            ({{
                                              filterTimeFormat(
                                                docType.effectiveDateTime[index]
                                              )
                                            }})
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </li>
                              </ul>
                              <ul
                                v-for="singlevisit in visitFormObj[
                                  visit.visitNo + patient.patientId
                                ][vIndex].data"
                                :key="singlevisit.sheduleId"
                              >
                                <li>
                                  <input
                                    v-if="singlevisit.templateName"
                                    type="checkbox"
                                    @click.prevent="
                                      gotoform(singlevisit, patient.subjectId, site.siteCode)
                                    "
                                  />
                                   <label class="tree_form" @click.prevent>
                                      <div class="d-flex align-items-center form-row-line">
                                        <span class="form-name-text" @click.prevent.stop="
                                          gotoform(
                                            singlevisit,
                                            patient.subjectId,
                                            site.siteCode
                                          )
                                          ">{{
        singlevisit.formStatus === "Completed"
          ? singlevisit.templateName +
          " -" +
          (singlevisit.visitCompletedDate
            ? " " + filter(singlevisit.visitCompletedDate)
            : "")
          : singlevisit.formStatus === "Planned" ||
            singlevisit.formStatus === "Overdue" ||
                                          singlevisit.formStatus === "Imminent"
                                          ? singlevisit.templateName
                                          : singlevisit.formStatus === "Pending"
                                          ? singlevisit.templateName
                                          : singlevisit.templateName
                                          }}

                                          <span class="badge custom-form-tooltip-wrapper"
                                            @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-${pIndex}-${vIndex}`)"
                                            @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-${pIndex}-${vIndex}`)"
                                            :popovertarget="`formStatus-${singlevisit.sheduleId}-${pIndex}-${vIndex}`"
                                            :style="`background-color: ${singlevisit.formStatusHex}; color: black; anchor-name:--formStatus-${singlevisit.sheduleId}-${pIndex}-${vIndex};`">
                                            {{ singlevisit.formStatus }}
                                          </span>
                                          <span v-if="singlevisit.formStatusDescription" popover
                                            class="custom-form-tooltip-text"
                                            :id="`formStatus-${singlevisit.sheduleId}-${pIndex}-${vIndex}`"
                                            :style="`position-anchor:--formStatus-${singlevisit.sheduleId}-${pIndex}-${vIndex};`">
                                            {{ singlevisit.formStatusDescription }}
                                          </span>
                                        </span>

                                        <span v-if="!visit.visitNo && !visit.visitName" class="form-name-text">
                                          {{ singlevisit.visitDate ? filter(singlevisit.visitDate) : '' }}
                                        </span>

                                        <button v-if="singlevisit.formStatus !== 'Completed'"
                                          :popovertarget="popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex)"
                                          :anchor="popoverId('visitForms', sIndex, pIndex, vIndex)"
                                          class="visit-ellipsis-btn py-0 px-3 ms-auto" @click.stop>
                                          <i class="fa fa-ellipsis-v"></i>
                                        </button>

                                        <div :id="popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex)" popover
                                          class="visit-popup-menu">
                                          <button @click.prevent.stop="
                                            openChangeStatusmodal(
                                              visit.studyId,
                                              visit.visitNo,
                                              patient.patientId,
                                              visit.visitStatus,
                                              vIndex,
                                              'Form',
                                              popoverId(singlevisit.sheduleId, sIndex, pIndex, vIndex),
                                              visit.visitName,
                                              singlevisit.formStatus,
                                              singlevisit.formId,
                                              singlevisit.sheduleId
                                            )
                                            " class="popup-menu-block text-left w-100">
                                            {{ $t("navigations.change status") }}
                                          </button>
                                        </div>
                                      </div>
                                    </label>

                                </li>
                              </ul>
                            </template>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              </ul>
            </template>
            
          </div>
        </div>
      </div>
      <div
        v-if="roleprivileges.includes('ePRO Subjects Recent Forms')"
        class="col-12 col-md-6 mb-1"
      >
          <!-- <div class="ibox-title style_2">
            <h5 class="float-left">{{ $t("navigations.recent form") }}</h5>
          </div> -->
          <div class="ibox-content minheight">
            <h4 class="float-left">{{ $t("navigations.recent form") }}</h4>
            <div class="text-center" v-if="showRecentFormLoading==true">
               <img
                src="../../assets/img/loading.gif"
                width="15"
                class=""
                alt="Waiting for login"
              />
              <div>
                {{
                  $t("navigations.please wait while the list is being loaded")
                }}
                </div>
            </div>
            <template v-else>
              <div class="text-center" v-if="recentformList.length==0">
                <h4>{{ $t('navigations.no recent forms available') }}</h4>
              </div>
              <template v-else>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>{{ $t("navigations.site code") }}</th>
                        <th>{{ $t("navigations.subject id") }}</th>
                        <th
                          class="sort_block"
                          @click="SortSelectforms('visitName', 11)"
                          id="11"
                        >
                          <div class="d-flex flex-row justify-content-between">
                            {{ $t("navigations.visit name") }}
                            <span>
                              <i class="fa fa-long-arrow-up"></i>
                              <i class="fa fa-long-arrow-down"></i>
                            </span>
                          </div>
                        </th>
                        <th class="sort_block" @click="SortSelectforms('formName', 0)" id="0">
                          <div class="d-flex flex-row justify-content-between">
                            {{ $t("navigations.form name") }}
                            <span>
                              <i class="fa fa-long-arrow-up"></i>
                              <i class="fa fa-long-arrow-down"></i>
                            </span>
                          </div>
                        </th>
                        <th
                          class="sort_block"
                          @click="SortSelectforms('createdUserName', 12)"
                          id="12"
                        >
                          <div class="d-flex flex-row justify-content-between">
                            {{ $t("navigations.uploaded by") }}
                            <span>
                              <i class="fa fa-long-arrow-up"></i>
                              <i class="fa fa-long-arrow-down"></i>
                            </span>
                          </div>
                        </th>
                        <th
                          class="sort_block"
                          @click="SortSelectforms('createdAt', 13)"
                          id="13"
                        >
                          <div class="d-flex flex-row justify-content-between">
                            {{ $t("navigations.uploaded date") }}
                            <span>
                              <i class="fa fa-long-arrow-up"></i>
                              <i class="fa fa-long-arrow-down"></i>
                            </span>
                          </div>
                        </th>
                        <th class="text-center">{{ $t("navigations.view") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in recentformList" :key="item.createdAt">
                        <td>{{ item.siteCode }}</td>
                        <td>{{ item.subjectCode }}</td>
                        <td>{{ item.visitName }}</td>
                        <td>{{ item.formName }}</td>
                        <td>{{ item.createdUserName }}</td>
                        <td>{{ filter(item.createdAt) }}</td>
                        <td class="text-center">
                          <i
                            class="fa fa-eye editicon"
                            aria-hidden="true"
                            @click.prevent="
                              viewform(item.formId, item.siteId, item.subjectId)
                            "
                          ></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row mt-3 mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div
                  class="dataTables_paginate paging_simple_numbers pagination float-right"
                >
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination
                      v-model="currentRecentformPage"
                      :pages="totalformsPages"
                      :range-size="1"
                      active-color="#618bd7"
                      @update:modelValue="loadrecentForm"
                    />
                  </div>
                </div>
              </div>
            </div>
              </template>            
            </template>
           
          </div>
         
      </div>
    </div>
  </div>
<!-- Assign form modal starts -->
 <!-- <customModal v-if="showAssignForm==true" :containermd="true" @closeModal="closeAssignFormModal()">
    <template #title>
      {{ $t("navigations.forms") }}
    </template>
    <template #body>
        <table class="table features-table">
        <p v-if="ecrfformlist == ''" class="mb-0 text-center">
          {{ $t("navigations.no forms added") }}
        </p>
        <tbody>
          <tr v-for="forms in ecrfformlist" :key="forms.id">
            <td>{{ forms.templateName }} ({{ forms.version }})</td>
            <td class="d-flex align-items-start" style="gap: 1rem">
              <div>
                <div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'selectDate-' + forms.id"
                    v-model="forms.useDate"
                    :checked="forms.useDate"
                    @change="
                      forms.useRecurrence = false;
                      if (!forms.useDate) {
                        forms.selectedDate = '';
                      }
                    "
                  />
                  <label
                    class="form-check-label"
                    :for="'selectDate-' + forms.id"
                  >
                    Select Date
                  </label>
                </div>
                <div v-if="forms.useDate" class="mb-2">
                  <input
                    type="date"
                    v-model="forms.selectedDate"
                    class="form-control"
                  />
                  <div
                    v-if="forms.useDate && !forms.selectedDate"
                    class="text-danger mt-1"
                    style="font-size: 12px"
                  >
                    Please select a date.
                  </div>
                </div>
              </div>
              <div>
                <div class="form-check mb-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'selectRecurrence-' + forms.id"
                    v-model="forms.useRecurrence"
                    :checked="forms.useRecurrence"
                    @change="
                      forms.useDate = false;
                      if (!forms.useRecurrence) {
                        forms.selectedRecurrence = '';
                        forms.recurrenceFromDate = '';
                        forms.occurrence = '';
                      }
                    "
                  />
                  <label
                    class="form-check-label"
                    :for="'selectRecurrence-' + forms.id"
                  >
                    Recurrence Cycle
                  </label>
                </div>
                <div v-if="forms.useRecurrence">
                  <select
                    v-model="forms.selectedRecurrence"
                    class="form-control mb-2"
                  >
                    <option disabled value="">Select cycle</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                  <div
                    v-if="
                      forms.useRecurrence && !forms.selectedRecurrence
                    "
                    class="text-danger mt-1"
                    style="font-size: 12px"
                  >
                    Please select a recurrence cycle.
                  </div>
                  <input
                    type="date"
                    v-model="forms.recurrenceFromDate"
                    class="form-control mb-2"
                    placeholder="From Date"
                  />
                  <div
                    v-if="
                      forms.useRecurrence && !forms.recurrenceFromDate
                    "
                    class="text-danger mt-1"
                    style="font-size: 12px"
                  >
                    Please select a from date.
                  </div>
                  <input
                    type="number"
                    v-model.number="forms.occurrence"
                    class="form-control"
                    min="1"
                    placeholder="Occurrence"
                  />
                  <div
                    v-if="
                      forms.useRecurrence &&
                      (!forms.occurrence || forms.occurrence < 1)
                    "
                    class="text-danger mt-1"
                    style="font-size: 12px"
                  >
                    Please enter a valid occurrence (min 1).
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">
              <button
                class="btn btn-primary btn-sm"
                @click="saveForm(forms)"
              >
                Save
              </button>
            </td>
            <td></td>
          </tr>
        </tbody>
        </table>
    </template>
 </customModal> -->
<!-- Assign form modal ends -->


<!-- Assign form popup starts -->
<AssignEproPopup
  v-if="showAssignForm"
  :subjectId="selectedPatientId"
  :visitName="selectedVisitName"
  @closemodal="closeAssignFormModal"
/>
<!-- Assign popup ends -->



  <!-- modal starts -->
  <div class="modal-wrapper">
    <div class="modal-container">
      <div class="titleclass">
        <h4 class="px-3 mt-1">{{ $t("navigations.add form") }}</h4>
        <div class="closebutton mt-1">
          <a style="color: white" class="close-link">
            <i class="fa fa-times" @click.prevent="closeModal"></i>
          </a>
        </div>
      </div>
      <div class="modelbody p-0">
        <!-- test -->
        <div class="mb-3 p-2">
          <div class="form-group">
            <div class="d-flex flex-column flex-lg-row">
              <div class="col-lg-12 my-2">
                <select
                  class="form-control"
                  placeholder="Search by Status"
                  v-model="selectedTemplate"
                >
                  <option value="" disabled selected>
                    {{ $t("navigations.select forms") }}
                  </option>
                  <option
                    v-for="templates in templateList"
                    :key="templates.templateId"
                    :value="templates.templateId"
                  >
                    {{ templates.templateName }} ({{ templates.version }}) - {{ templates.languageCode.toUpperCase() }} 
                  </option>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center my-3">
              <button
                class="save_btn py-1 px-4"
                @click.prevent="
                  gotofillform(
                    selectedVisit.visit,
                    selectedVisit.subjectId,
                    selectedVisit.siteCode
                  )
                "
              >
                {{ $t("navigations.fill form") }}
              </button>
            </div>
          </div>
        </div>
        <!-- test -->
      </div>
    </div>
  </div>

  <CreateVideoCallSchedulePopUp
    v-if="CreateVideoCallSchedulePopUp"
    @closeModal="CreateVideoCallSchedulePopUp = false"
    :patientid="selectedPatientId"
    :fromPage="'FillForm'"
  />

  <!-- Change schedule status  -->
  <ChangeSchedulestatus
    v-if="showChangeSchedule"
    :statusType="statusType"
    :changeStatus="changeStatus"
    :selectedScheduleId="scheduleId"
    :selectedFormId="selectedForm"
    @changeStatus="changedStatus()"
    @closeModal="closeChangeScheduleModal()"
  />
  <!-- End of Change schedule status  -->

  <!-- Visit form list modal starts -->
  <div class="modal__schedule__wrapper" v-if="sohowFormModal">
    <div class="modal__schedule__container-forms">
      <div class="modal__schedule__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.forms") }}</h4>
        <div class="cursor-pointer">
          <i class="fa fa-times" title="Close" @click.prevent="closeFormsModal()"> </i>
        </div>
      </div>
      <div class="modal-body overflow-block-form">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12">
              <table class="table features-table">
                <tbody>
                  <p v-if="formlist.data == ''" class="mb-0 text-center">
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tr v-for="forms in formlist" :key="forms.sheduleId">
                    <td>{{ forms.templateName }}</td>

                    <td>
                      <span
                        class="badge badge-grn"
                        v-if="forms.visitStatus == 'Completed'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="forms.visitStatus == 'Overdue'"
                        >{{ forms.visitStatus }}
                      </span>
                      <span
                        class="badge badge-yellow"
                        v-if="forms.visitStatus == 'Imminent'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-gray"
                        v-if="forms.visitStatus == 'Withdrawn'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-blue"
                        v-if="forms.visitStatus == 'Planned'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-orage"
                        v-if="forms.visitStatus == 'Pending'"
                        >{{ forms.visitStatus }}
                      </span>
                    </td>
                    <td class="text-center">
                      <i
                        class="fa fa-plus-square edit-delete"
                        title="Fill Form"
                        @click.prevent="goTovisitTemplate([forms], forms.patientId)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Visit form list modal ends -->
  <!-- Visit form list modal starts -->
  <div class="modal__schedule__wrapper" v-if="sohowFormModalImminent">
    <div class="modal__schedule__container-forms">
      <div class="modal__schedule__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.forms") }}</h4>
        <div class="cursor-pointer">
          <i class="fa fa-times" title="Close" @click.prevent="closeImminentFormsModal()">
          </i>
        </div>
      </div>
      <div class="modal-body overflow-block-form">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12">
              <table class="table features-table">
                <tbody>
                  <p v-if="formlist.data == ''" class="mb-0 text-center">
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tr v-for="forms in formlist" :key="forms.sheduleId">
                    <td>{{ forms.templateName }}</td>
                    <td>
                      <span
                        class="badge badge-grn"
                        v-if="forms.visitStatus == 'Completed'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="forms.visitStatus == 'Overdue'"
                        >{{ forms.visitStatus }}
                      </span>
                      <span
                        class="badge badge-yellow"
                        v-if="forms.visitStatus == 'Imminent'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-gray"
                        v-if="forms.visitStatus == 'Withdrawn'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-blue"
                        v-if="forms.visitStatus == 'Planned'"
                        >{{ forms.visitStatus }}</span
                      >
                      <span
                        class="badge badge-orage"
                        v-if="forms.visitStatus == 'Pending'"
                        >{{ forms.visitStatus }}
                      </span>
                    </td>
                    <td class="text-center">
                      <i
                        class="fa fa-plus-square edit-delete"
                        title="Fill Form"
                        @click.prevent="goTovisitTemplate([forms])"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Visit form list modal ends -->
</template>
<script src="./eproSubjects.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "./tree.css";
/* Tooltip box */
/* Tooltip box */
.custom-tooltip-text,
.custom-form-tooltip-text {
    position: absolute;
    inset: auto;
    margin: 0;
    bottom: anchor(top);
    right: anchor(right);
    background-color: #616161;
    color: white;
    padding: 6px 10px;
    font-size: 0.75rem;
    border-radius: 4px;
    border: none;
    max-width: 180px;
    white-space: normal;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    margin-block-end: 4px;

}
.custom-tooltip-text:popover-open{
  display: grid;
}
.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.visit-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.visit-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.visit-popup-menu > button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.visit-popup-menu > .popup-menu-block:hover,
.popup-submenu > div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left);
}

/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}
.minheight {
    min-height: 82vh;
}
.form-row-line {
  gap: 6px;
  flex-wrap: nowrap;
}

.form-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
